//footer first row static data
// Each item: { label, to } for internal React Router links
export const footerCategories = [
  {
    section: "NEWS",
    subSections: [
      { label: "Home Page", to: "/" },
      { label: "World", to: "/section/world" },
      { label: "U.S.", to: "/section/us" },
      { label: "Politics", to: "/section/politics" },
      { label: "Local", to: "/section/local" },
      { label: "Business", to: "/section/business" },
      { label: "Tech", to: "/section/technology" },
      { label: "Science", to: "/section/science" },
      { label: "Climate", to: "/section/climate" },
      { label: "Sports", to: "/section/sports" },
      { label: "Obituaries", to: "/section/obituaries" },
      { label: "Trending", to: "/query/trending" },
    ],
  },
  {
    section: "OPINION",
    subSections: [
      { label: "Today's Opinion", to: "/section/opinion" },
      { label: "Columnists", to: "/query/columnist" },
      { label: "Editorials", to: "/section/editorial" },
      { label: "Guest Essays", to: "/section/opinion" },
    ],
  },
  {
    section: "ARTS",
    subSections: [
      { label: "Today's Arts", to: "/section/arts" },
      { label: "Art & Design", to: "/section/arts" },
      { label: "Books", to: "/section/books" },
      { label: "Movies", to: "/section/movies" },
      { label: "Music", to: "/section/music" },
      { label: "Pop Culture", to: "/section/arts" },
      { label: "Television", to: "/section/television" },
    ],
  },
  {
    section: "LIVING",
    subSections: [
      { label: "Automotive", to: "/section/automotive" },
      { label: "Education", to: "/section/education" },
      { label: "Food", to: "/section/food" },
      { label: "Health", to: "/section/health" },
      { label: "Magazine", to: "/section/magazine" },
      { label: "Parenting", to: "/section/parenting" },
      { label: "Real Estate", to: "/section/realestate" },
      { label: "Style", to: "/section/style" },
      { label: "The Agentic", to: "/section/the-agentic" },
      { label: "Travel", to: "/section/travel" },
    ],
  },
];

// footer second row static data
// { label, to } for internal links; { label } for plain text (copyright)
export const footerLastRowData = [
  { label: `© ${new Date().getFullYear()} Fishstock News` },
  { label: "About", to: "/about" },
  { label: "Contact Us", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Site Map", href: "/sitemap.xml" },
  { label: "Agents", href: "https://theagentic.news/agents.xml" },
  { label: "RSS", href: "https://theagentic.news/rss.xml" },
];
